<mat-card
  class="search-result-card mat-elevation-z0"
  matRipple
  [routerLinkActive]="link ? 'is-active' : ''"
  [attr.aria-label]="person ? person.fullName : 'Click to search'"
  [routerLink]="link"
  tabindex="0"
  (keydown.enter)="onClickRouterLink()"
>
  <div *ngIf="person" fxLayout="row" fxLayoutAlign="space-between" class="card-container">
    <mat-card-header fxFlex="85">
      <lineup-avatar
        [ngClass]="{ 'non-empty-seat': true, 'archived-avatar': person.isArchived() }"
        matCardAvatar
        [image]="person.image"
        [thumbnail]="true"
        [selected]="person.selected"
        (click)="onClickAvatar($event, person)"
      ></lineup-avatar>
      <mat-card-title class="mat-card-title">
        <span
          class="card-fullname"
          [ngClass]="{ 'non-empty-seat': true, 'archived-text': person.isArchived() }"
          id="card-full-name-label"
          >{{ person.fullName }}</span
        >
        <span *ngIf="getRating()" class="person-star-rating">
          <app-star-rating
            class="evaluation-star-rating"
            matTooltip="{{ getExactRating() }}"
            matTooltipPosition="right"
            matTooltipShowDelay="500"
            [rating]="getRating()"
            [readOnly]="true"
          ></app-star-rating>
        </span>
        <button
          *ngIf="person?.activeTeamsCount > 0"
          class="active-teams-tag is-hidden"
          tabindex="0"
          [center-mat-menu]="menuTrigger"
          [data-loading-subject]="dataLoadingSubject"
          (throttledClick)="openMenu()"
          appThrottleClick
        >
          {{ person?.activeTeamsCount }} active team<span *ngIf="person?.activeTeamsCount > 1">s</span>
        </button>
        <button
          *ngIf="currentTeamsCount > 0"
          class="active-teams-tag"
          [center-mat-menu]="menuCurrentTrigger"
          (throttledClick)="openCurrentMenu()"
          appThrottleClick
        >
          {{ currentTeamsCount }} current
        </button>
        <button
          *ngIf="upcomingTeamsCount > 0"
          class="upcoming-teams-tag upcoming-margin"
          [center-mat-menu]="menuUpcomingTrigger"
          (throttledClick)="openUpcomingMenu()"
          appThrottleClick
        >
          {{ upcomingTeamsCount }} upcoming
        </button>
        <mat-chip *ngIf="person?.isUnsubscribed == 'UnSubscribed'" class="unsubscribed-tag">Unsubscribed</mat-chip>
        <mat-chip *ngIf="person?.isPotential()" class="status-tag">Potential</mat-chip>
        <mat-chip *ngIf="person?.isArchived()" class="status-tag">Archived</mat-chip>
        <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></div>
        <mat-menu #menu="matMenu" yPosition="above">
          <div class="active-teams-container">
            <p class="active-teams-title">ACTIVE TEAMS</p>
            <div *ngFor="let team of personTeams" fxLayout="row" fxLayoutAlign="space-between center">
              <a fxFlex (click)="goToTeam(team.id)" class="team-name">
                {{ team.teamName }}
              </a>
              <p fxFlex="30" class="team-status">
                <svg width="15" height="10">
                  <circle [class]="team.status" class="status-dot" cx="5" cy="5" r="4" stroke-width="0" />
                </svg>
                {{ team.status }}
              </p>
            </div>
          </div>
        </mat-menu>
        <div #menuCurrentTrigger="matMenuTrigger" [matMenuTriggerFor]="menuCurrent"></div>
        <mat-menu #menuCurrent="matMenu" yPosition="above">
          <div class="active-teams-container">
            <p class="active-teams-title">CURRENT TEAMS</p>
            <div *ngFor="let team of personCurrentTeams" fxLayout="row" fxLayoutAlign="space-between center">
              <a
                fxFlex
                [class.disabled]="!isTeamInActiveWorkspace(team)"
                [class.archived-team]="!team.isActive"
                (click)="goToTeam(team.id)"
                class="team-name"
              >
                {{ team.teamName }}
              </a>
              <p fxFlex="30" class="team-status">
                <svg width="15" height="10">
                  <circle [class]="team.status" class="status-dot" cx="5" cy="5" r="4" stroke-width="0" />
                </svg>
                {{ team.status }}
              </p>
            </div>
          </div>
        </mat-menu>
        <div #menuUpcomingTrigger="matMenuTrigger" [matMenuTriggerFor]="menuUpcoming"></div>
        <mat-menu #menuUpcoming="matMenu" yPosition="above">
          <div class="active-teams-container">
            <p class="active-teams-title">UPCOMING TEAMS</p>
            <div *ngFor="let team of personUpcomingTeams" fxLayout="row" fxLayoutAlign="space-between center">
              <a fxFlex (click)="goToTeam(team.id)" class="team-name">
                {{ team.teamName }}
              </a>
              <p fxFlex="30" class="team-status">
                <svg width="15" height="10">
                  <circle [class]="team.status" class="status-dot" cx="5" cy="5" r="4" stroke-width="0" />
                </svg>
                {{ team.status }}
              </p>
            </div>
          </div>
        </mat-menu>
      </mat-card-title>
      <mat-card-subtitle>
        <mat-chip-list role="presentation">
          <mat-chip class="attribute-tag" *ngFor="let attr of person?.featuredCustomFields">
            <div [class.ellipsis-text]="attr.value.length > 40" [matTooltip]="attr.value.length > 40 ? attr.value : ''">
              {{ attr.value }}
            </div>
          </mat-chip>
          <mat-chip class="person-tag" *ngFor="let tag of person?.tags">
            <div [class.ellipsis-text]="tag.text.length > 40" [matTooltip]="tag.text.length > 40 ? tag.text : ''">
              {{ tag.text }}
            </div>
          </mat-chip>
        </mat-chip-list>
      </mat-card-subtitle>
    </mat-card-header>
    <seat-status-override
      class="vertical-center"
      (throttledClick)="openMenu()"
      appThrottleClick
      [seat]="seat"
    ></seat-status-override>
  </div>
  <div *ngIf="!person">
    <mat-card-header class="empty-seat">
      <div class="empty-seat-icon" mat-card-avatar fxLayout="row" fxLayoutAlign="center center">
        <mat-icon>search</mat-icon>
      </div>
      <mat-card-title>Empty</mat-card-title>
      <mat-card-subtitle *ngIf="showSearchHint" id="person-card" class="empty-card-subtitle"
        >Click to Search</mat-card-subtitle
      >
    </mat-card-header>
  </div>
</mat-card>
